import type { Variant } from 'types/product/Variant';
import { convertToNumber } from 'utils/convertToNumber';
import { formatShopifyPrice } from 'utils/formatShopifyPrice';

import type { ShopifyProductRaw } from './mapShopifyProduct';

type ShopifyVariantRaw = NonNullable<
  ShopifyProductRaw['variants']['edges']
>[number]['node'];

export const mapProductVariant = (variant: ShopifyVariantRaw): Variant => ({
  id: variant.id,
  title: variant.title,
  availableForSale: variant.availableForSale,
  price: formatShopifyPrice(variant.price),
  compareAtPrice: variant.compareAtPrice
    ? formatShopifyPrice(variant.compareAtPrice)
    : null,
  maxQuantity: convertToNumber(variant.maxQuantity?.value) || null,
  servings: convertToNumber(variant.servings?.value) || null,
  netContents: variant.netContents?.value || null,
  sku: variant.sku || null,
  imageUrl:
    variant.image?.url && typeof variant.image?.url === 'string'
      ? variant.image.url
      : undefined,
});
